<template>
  <router-link :to="ecrantSuivant" class="appcompetences_footer_suivant">Passer cette question &gt;</router-link>
</template>

<script>
export default {
  name: 'skip-competences',
  props: ['ecrantSuivant']
}
</script>

<style scoped>
.appcompetences_footer_suivant {
  color: #002e5d;
  cursor: pointer;
  font-size: 1.2rem;
  float: right;
  margin: .5em;
  padding: 1rem 2.5rem;
}
</style>